import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import { keysToCamelCase } from "lib/helpers";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../../messages";

function* getActiveWorkflow() {
  const { success, data, error } = yield* makeRequest.get("/workflows/active", {});
  if (success && data) {
    const workflow = keysToCamelCase(data.body.workflow);
    yield put(actions.setWorkflowDetails(workflow));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_WORKFLOW_DETAILS,
    });
  }
  return null;
}

export default getActiveWorkflow;
